import React from 'react';

import { Button, Stack, Text, Title } from '@mantine/core';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { useCheckout } from '../../CheckoutContext';

const FALLBACK_MESSAGE =
  "This class can't be scheduled right now because of time or credit constraints, or because it's at full capacity. Please select another class or contact gym staff.";

const KiloClassScheduleError = (): JSX.Element => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { kiloClassErrorMessage } = useCheckout();

  const handleBackToCalendar = (): void => {
    const redirectUrl = searchParams.get('from');

    if (redirectUrl) {
      window.location.href = redirectUrl;
    } else {
      navigate(-1);
    }
  };

  return (
    <Stack spacing='lg' align='center' p='xl'>
      <Title order={2} align='center' fw={700}>
        This class can&apos;t be scheduled
      </Title>

      <Text c='dimmed' size='sm' align='center' maw={500}>
        {kiloClassErrorMessage || FALLBACK_MESSAGE}
      </Text>

      <Button size='lg' onClick={handleBackToCalendar} mt='md'>
        Back to Calendar
      </Button>
    </Stack>
  );
};

export default KiloClassScheduleError;
